export default "__VITE_ASSET__5ee258e2__"